import { EditorState, Modifier } from "draft-js";
import React, {useEffect} from "react";

export const InsertDash = ({ editorState, onChange, setEditingEntity }) => {

    useEffect(() => {
        addDashToContent();
        setEditingEntity(null);
    }, []);

    const addDashToContent = () => {
        const currentContent = editorState.getCurrentContent();
        const currentSelection = editorState.getSelection();
        const newContent = Modifier.replaceText(currentContent, currentSelection, "–");
        const newEditorState = EditorState.push(editorState, newContent, "insert-characters");
        onChange(newEditorState);
        setEditingEntity(null);
    };

    return null;
};
